import { Box, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CompletitionStatus, LinearProgressCustom } from "../../components/CarouselCardRestyle/CarouselCard.style";

type IProgressBar = {
    progression: string
}

export const ProgressBar = ({
  progression
}: IProgressBar)=> {
  const theme = useTheme();
  const { t } = useTranslation();
  const isTablet = useMediaQuery(theme.breakpoints.down("sm"));
  function handleProgressionValue() {
    if (progression && progression !== "0%") {
      return Number(progression.replace("%", ""));
    }
    return 1;
  }

  return (
    <Stack direction={ "column" } maxWidth={ isTablet ? "100%" : "34%" } marginBottom="0.5rem">
      <LinearProgressCustom
        aria-label={ t("activity_progress") }
        variant="determinate"
        value={ handleProgressionValue() }
      />
      <CompletitionStatus id={ "completion-status" }>
        <Box
          sx={ {
            height: "1.44rem",
            display: "flex",
            alignItems: "center"
          } }
        >
          <Typography
            color={ theme.customColors.textPrimary }
            fontSize={ "0.75rem" }
          >
            { t("completion") }
          </Typography>
        </Box>

        <Typography
          color={ theme.customColors.textPrimary }
          fontSize={ "0.75rem" }
        >
          { progression ?? "0%" }
        </Typography>
      </CompletitionStatus>
    </Stack>
  );
};
